import { memo } from "react";
import type { GridCellParams } from "@mui/x-data-grid-premium";
import { Filters, MerchantPayoutsTabs } from "consts/merchantPayouts";
import { TableGridMode } from "consts/table";
import { date, FilterVariant } from "consts/filters";
import { multiColumnFilterFactory } from "util/filters";
import useActions from "features/merchantPayouts/useActions";
import Filable from "../Filable";
import Actions from "./Actions";

const SummaryFiles = () => {
    const {
        getMerchantPayoutSummaryFiles,
        postMerchantPayoutSummaryFiles,
        mergeMerchantPayoutSummaryFiles
    } = useActions();

    return (
        <Filable
            mode={TableGridMode.MerchantPayoutsSummaryFiles}
            filterTypes={new Map<FilterVariant, string[]>([
                [FilterVariant.Text, [
                    Filters.fileKey,
                    Filters.amountPaid
                ]],
                [FilterVariant.DateRange, [
                    ...date,
                    multiColumnFilterFactory([
                        Filters.dateFrom,
                        Filters.dateTo
                    ])
                ]]
            ])}
            fetchTableData={getMerchantPayoutSummaryFiles}
            formId={MerchantPayoutsTabs.SummaryFiles}
            dialogTitleSlot='Create Payout Summary File'
            createNewFileRequestHandler={postMerchantPayoutSummaryFiles}
            mergeFilesRequestHandler={mergeMerchantPayoutSummaryFiles}
            columns={[
                {
                    field: 'actions',
                    renderCell: (params: GridCellParams) => (
                        <Actions {...params} />
                    )
                }
            ]}
        />
    );
};

export default memo(SummaryFiles);
